import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import api from "../../lib/api";
import { Filter, Heart } from "lucide-react";
import { useCart } from "../../context/CartContext";

const FILTERS = ["All", "Sunglasses", "Optical", "Sport", "Golf", "Women"];

export default function AppShop() {
  const [items, setItems] = useState([]);
  const [cat, setCat] = useState("All");
  const { toggleWishlist, isWishlisted } = useCart();

  useEffect(() => { api.get("/products").then(r => setItems(r.data || [])); }, []);

  const list = useMemo(() => cat === "All" ? items : items.filter(i => i.category === cat), [items, cat]);

  return (
    <div data-testid="app-shop" className="pb-6">
      <header className="px-5 pt-12 pb-3 flex items-center justify-between">
        <div className="text-[11px] tracking-luxury uppercase text-white/55">Shop</div>
        <button className="text-white/75 flex items-center gap-1 text-[10px] tracking-luxury uppercase">
          <Filter size={14} /> Filter
        </button>
      </header>

      {/* Filter chips */}
      <div className="flex gap-2 px-5 overflow-x-auto no-scrollbar">
        {FILTERS.map(f => (
          <button
            key={f}
            data-testid={`app-filter-${f.toLowerCase()}`}
            onClick={() => setCat(f)}
            className={`px-4 py-1.5 text-[10px] tracking-luxury uppercase whitespace-nowrap border ${cat === f ? "bg-poche-gold text-poche-black border-poche-gold" : "border-white/15 text-white/70"}`}
          >
            {f}
          </button>
        ))}
      </div>

      <div className="px-5 mt-4 text-[10px] tracking-luxury uppercase text-white/45">{list.length} pieces</div>

      <div className="grid grid-cols-2 gap-3 px-5 mt-2">
        {list.map((p) => {
          const wished = isWishlisted(p.product_id);
          return (
            <Link key={p.product_id} to={`/app/product/${p.product_id}`} className="block" data-testid={`app-shop-card-${p.product_id}`}>
              <div className="bg-poche-ivory aspect-square relative overflow-hidden">
                <img src={p.images[0]} alt={p.name} className="w-full h-full object-cover" />
                <button onClick={(e) => { e.preventDefault(); toggleWishlist(p); }} className="absolute top-2 right-2 bg-white/85 w-7 h-7 flex items-center justify-center">
                  <Heart size={12} fill={wished ? "#0A0A0A" : "none"} stroke="#0A0A0A" />
                </button>
              </div>
              <div className="mt-2">
                <div className="text-[10px] tracking-luxury uppercase text-white/55">{p.name}</div>
                <div className="font-serif text-base">{p.subtitle}</div>
                <div className="text-poche-gold text-sm">${p.price.toLocaleString()}</div>
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
